import type { DesignModule } from '../types'
import { LedgerAdminApiTokens } from './components/admin-api-tokens-screen'
import { LedgerAdminCredentials } from './components/admin-credentials-screen'
import { LedgerAdminLocations } from './components/admin-locations-screen'
import { LedgerAdminPermissions } from './components/admin-permissions-screen'
import { LedgerAdminRoles } from './components/admin-roles-screen'
import { LedgerAdminTenantDetail, LedgerAdminTenants } from './components/admin-tenants-screen'
import { LedgerAdminUsers } from './components/admin-users-screen'
import { LedgerClients } from './components/clients-screen'
import { LedgerDashboard } from './components/dashboard-screen'
import { LedgerLocationDetail } from './components/location-detail-screen'
import { LedgerLocations } from './components/locations-screen'
import { LedgerManagedDevices } from './components/managed-devices-screen'
import { LedgerNetwork } from './components/network-screen'
import { LedgerPosTerminals } from './components/pos-terminals-screen'
import { LedgerReservations } from './components/reservations-screen'
import { LedgerShell } from './components/shell'
import { LedgerSwitchPorts } from './components/switch-ports-screen'
import { LedgerWanSettings } from './components/wan-settings-screen'

export const v3: DesignModule = {
  name: 'Ledger',
  description: 'Warm editorial: serif headings, paper tones, ruled tables, terracotta accent.',
  Shell: LedgerShell,
  screens: {
    dashboard: LedgerDashboard,
    locations: LedgerLocations,
    locationDetail: LedgerLocationDetail,
    network: LedgerNetwork,
    wanSettings: LedgerWanSettings,
    managedDevices: LedgerManagedDevices,
    reservations: LedgerReservations,
    switchPorts: LedgerSwitchPorts,
    clients: LedgerClients,
    posTerminals: LedgerPosTerminals,
    adminUsers: LedgerAdminUsers,
    adminRoles: LedgerAdminRoles,
    adminPermissions: LedgerAdminPermissions,
    adminTenants: LedgerAdminTenants,
    adminTenantDetail: LedgerAdminTenantDetail,
    adminApiTokens: LedgerAdminApiTokens,
    adminCredentials: LedgerAdminCredentials,
    adminLocations: LedgerAdminLocations,
  },
}
